import React, { useMemo } from "react";
import { motion } from "framer-motion";

const VIEWPORT = { once: true, amount: 0.2 };
const EASE = [0.2, 0.8, 0.2, 1];

export default function Reveal({ children, delay = 0, y = 30, className = "" }) {
  const config = useMemo(
    () => ({
      initial: { opacity: 0, y },
      whileInView: { opacity: 1, y: 0 },
      viewport: VIEWPORT,
      transition: { duration: 0.8, delay, ease: EASE },
    }),
    [y, delay]
  );

  return (
    <motion.div {...config} className={className}>
      {children}
    </motion.div>
  );
}
